import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostOperationalCostPassword,
	OperationalCostPasswordParams,
	OperationalCostPasswordModel,
} from 'domain/usecases';

export class RemotePostOperationalCostPassword implements PostOperationalCostPassword {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<OperationalCostPasswordParams>,
	) {}

	async post(params: OperationalCostPasswordParams): Promise<OperationalCostPasswordModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			case HttpStatusCode.forbidden:
				throw new APIError(httpResponse.status, httpResponse.data);
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
